<template>
    <ui-dropdown menu-class="px-4 py-2 w-72" :placement="'right'" @closed="$emit('closed')">
        <template #default="{ toggle, open, close}">
            <div @mouseout="() => {(editMode?false:close());((channel.type!=='GROUP')?close():false)}"
                 :ref="'def'"
                 @mouseover="openIt(open,close)"
                 @click="($event) => {((channel.type!=='GROUP')?open():false);$emit('click', $event)}"
            >
                <message-widget-user-avatar
                    class="flex-1 flex items-center min-w-0 relative my-1"
                    :group="channel.type==='GROUP'"
                    :contacts="contacts"
                    :avatar="channel.avatarUrl"
                    :member-id="((channel.type==='DIRECT')|| (!channel.type))?channel.source:false"
                    :member-name="false"
                ></message-widget-user-avatar>
            </div>
        </template>
        <template #menu="{ close }" v-if="channel.type==='GROUP'">
            <div class="flex-1 flex items-center min-w-0 relative mb-3"><p
                class="text-lg text-brand font-semibold">Group Members</p>
            </div>
            <message-widget-user-avatar
                class="flex-1 flex items-center min-w-0 relative my-1"
                v-for="member in channel.members" v-if="member.active"
                :key="channel.id+'|'+member.id"
                :contacts="contacts"
                :avatar="member.avatarUrl"
                :member-id="member.id"
                :member-name="member.name"
                :removable="editMode"
                @removed="$emit('removed',member.id)"
            >
            </message-widget-user-avatar>
            <message-widget-user-avatar
                class="flex-1 flex items-center min-w-0 relative my-1"
                v-for="handle in channel.handles"
                :key="channel.id+'|'+handle"
                :contacts="contacts"
                :avatar="false"
                :member-id="false"
                :member-name="handle"
                :removable="editMode"
                @removed="$emit('removed',handle)"
            >
            </message-widget-user-avatar>
        </template>
        <template #menu="{ close }" v-else-if="channel.type!=='GROUP'">
            <div class="w-full relative m-0">
                <div class="w-full flex items-center justify-center">
                    <img :src="getAvatarUrl(channel.avatarUrl)"
                         alt=""
                         class="h-32 w-32 rounded-lg justify-center items-center">
                </div>
                <div class="w-full truncate flex mt-2 justify-center items-center">
                    <span class="text-xs font-medium text-gray-600 truncate" v-text="channel.name"></span>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import UiDropdown from "../../ui/UiDropdown.vue";
import MessageWidgetUserAvatar from "./MessageWidgetUserAvatar.vue";

export default {
    components: {MessageWidgetUserAvatar, UiDropdown},
    props: {
        channel: Object,
        contacts: [],
        disabled: false,
        editMode: false,
    },
    data() {
        return {
            close: Function,
        }
    },
    watch: {
        disabled: function (a, b) {
            if (a) {
                this.close()
            }
        }
    },
    methods: {
        openIt(open, close) {
            if (this.channel && (this.channel.type === 'GROUP') && !this.disabled) {
                open();
                this.close = close
            }
        },
        getTitle(id) {
            let contact = this.contacts.find((i) => i.id === id);
            if (contact) {
                return contact.name;
            }
            return '';
        },
        getAvatarUrl(url) {
            return url?url:'/img/user-placeholder.png'
        },

    },
    mounted() {
    },
}
</script>
